import { useTheme } from '@emotion/react';
import { ReactElement } from 'react';

import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';

const Component = ({ className }: { className: string }): ReactElement => {
	const theme = useTheme() as Theme;

	return (
		<div className={className}>
			<svg
				width={theme.allSettings.icons.openWidgetIcon.width}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M11.9924 15C12.2528 15 12.5032 14.8999 12.7035 14.7096L16.7095 10.7046C17.1001 10.3141 17.1001 9.68335 16.7095 9.29287C16.3189 8.90238 15.688 8.90238 15.2974 9.29287L12.0024 12.587L8.7075 9.29287C8.31692 8.90238 7.68597 8.90238 7.29538 9.29287C6.90479 9.68335 6.90479 10.3141 7.29538 10.7046L11.3014 14.7096C11.4817 14.8999 11.732 15 11.9924 15Z"
					fill="white"
				/>
			</svg>
		</div>
	);
};

export const CloseChatIcon = styled(Component)(
	({ theme }: { theme: Theme }) => theme.allSettings.icons.closeWidgetIcon
);
